import React, { useState } from "react";
import { Link } from "react-router-dom";
import ActionsTable from "./ActionsTable";
import { changeLogActionNames } from "../../constants";
import formatDate from "../../utils/formatDate";
import { teaserListDetail } from "../../utils/urls";

function actions2names(actionList) {
  return actionList.map(action => changeLogActionNames[action]).join(", ");
}

const EventItem = ({ event }) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => {
    setExpanded(!expanded);
  };

  return (
    <React.Fragment>
      <tr>
        <td>{formatDate(event.datetime)}</td>
        <td className="table__border-right">{event.user.name}</td>
        <td
          className="change-log__actions table__border-right"
          onClick={toggle}
        >
          {actions2names(event.action_ids)}
        </td>
        <td className="change-log__teaser-title table__border-right">
          <Link target="_blank" to={teaserListDetail(event.teaser.id)}>
            {event.teaser.title}
          </Link>
        </td>
        <td className="change-log__teaser-id">
          <Link target="_blank" to={teaserListDetail(event.teaser.id)}>
            {event.teaser.id}
          </Link>
        </td>
        <td>{event.fields_count}</td>
      </tr>
      {expanded && (
        <tr>
          <td colspan="6">
            <ActionsTable actions={event.actions} />
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};

export default EventItem;
